import { Heading, HStack, Image, Link, Stack } from '@chakra-ui/react';
import { FC } from 'react';
import { AppleStoreBadge, GooglePlayBadge } from '../../assets';
import { Card } from '../card';

export interface BoundlessAppLinkProps {
  heading: string;
  appleStoreLink: string;
  googlePlayLink: string;
}

export const BoundlessAppLink: FC<BoundlessAppLinkProps> = ({
  heading,
  appleStoreLink,
  googlePlayLink,
}): JSX.Element => (
  <Card px={4}>
    <Stack spacing={2}>
      <Heading fontSize="sm" fontWeight="bolder" textAlign="left">
        {heading}
      </Heading>
      <HStack justifyContent="space-between">
        <Link href={appleStoreLink}>
          <Image src={AppleStoreBadge} alt="apple store badge" />
        </Link>
        <Link href={googlePlayLink}>
          <Image src={GooglePlayBadge} alt="test google play badge" />
        </Link>
      </HStack>
    </Stack>
  </Card>
);
